module.exports = __webpack_public_path__ + "img/01.3a04bb9a.png";